import { render, staticRenderFns } from "./NumberBrandNameSetupTransaction.vue?vue&type=template&id=3ffcdc76"
import script from "./NumberBrandNameSetupTransaction.vue?vue&type=script&lang=js"
export * from "./NumberBrandNameSetupTransaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports